<template>
  <div class="qr-container" >
    <QrcodeVue v-if="is_qr_token" :value="value" :size="size" level="H" type="svg"></QrcodeVue>
    <div v-if="is_qr_svg" v-html="value" ></div>
    <img v-if="is_qr_image" :src="value"  />
    <div v-if="border" class="animated-border border rounded animate__animated" :class="animated_class"></div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
    props: {
        QRType: String,
        value: String,
        size: Number
    },
    components: {
        QrcodeVue
    },
    data(){
        return {
            animation: "animate__pulse",
            animated_class: "",            
            border: false            
        }
    },
    computed:{        
        is_qr_token()
        {
            return this.QRType == "QR_TOKEN";
        },
        is_qr_image()
        {
            return this.QRType == "QR_IMAGE";
        },
        is_qr_svg()
        {
            return this.QRType == "QR_SVG";
        },
    },
    watch:{
        value: function(){
            this.animated_class = this.animation;
            var self = this;
            setTimeout(() => {
                self.animated_class = "";
            }, 1500);
        }
    }
}
</script>

<style>

.qr-container{
    position: relative;
}

.animated-border {
    position: absolute;
    top:0;
    left:0;
    right: 0;
    bottom: 0;
    border-width: 3px !important;
}

</style>